import React, {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from "prop-types";

import IncrementComp from './incrementComp'
import {updateValues} from '../../../routers/data'
import {updateSettings, fetchAvailableDates} from '../../../routers/settings'
import Checkbox from 'material-ui/Checkbox';

const min = 0

class formPassenger extends Component{
  static contextTypes = {
    router: PropTypes.object
  }

  handleUpdate = (value) => {
    const values = {...this.props.values, ...value}
    this.props.updateValues(value)
    this.props.fetchAvailableDates(values, this.props.settings)
  }

  render(){
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].fastbooking.passengers

    const limits = (this.props.settings.limits !== undefined)? this.props.settings.limits: {}
    const {updateSettings, updateValues, enable} = this.props
    const {travel, nAdults, nTeens, nKids, nBabies, nPets, bFamily, bCouple} = this.props.values
    const footerProps = (enable) ? {onClick: () => updateSettings({'tab': 2})}: undefined
    const nextProps = (enable) ? {className: 'next'}: {className: 'next-disabled'}
    const maxTotal = limits.maxTotalPassengers

    return (
			<div className='container-fluid'>
        <div className='panel-passanger row'>
           <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
            <IncrementComp name='nAdults' value={nAdults} min={min} max={maxTotal - nTeens - nKids}
                    title={langPlace.adults} subtitle={langPlace.adultsdetails} onClick={this.handleUpdate} />
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
            <IncrementComp name='nTeens' value={nTeens} min={min} max={maxTotal - nAdults - nKids}
                    title={langPlace.teens} subtitle={langPlace.teensdetails} onClick={this.handleUpdate} />
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
            <IncrementComp name='nKids' value={nKids} min={min} max={maxTotal - nAdults - nTeens}
                    title={langPlace.kids} subtitle={langPlace.kidsdetails} onClick={this.handleUpdate} />
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
            <IncrementComp name='nBabies' value={nBabies} min={min} max={limits.maxBabies}
                    title={langPlace.babys} subtitle={langPlace.babysdetails} onClick={this.handleUpdate} />
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 no-padding'>
            <IncrementComp name='nPets' value={nPets} min={min} max={limits.maxPets}
                    title={langPlace.pets} subtitle={langPlace.petsdetails} onClick={this.handleUpdate} />
          </div>
          <div className='col-lg-12 col-md-12 col-sm-12 no-padding section-checkbox'>

            {/*<div className='col-md-12'>
              <Checkbox onCheck={(evt, isInputChecked) => updateValues({'bCouple': isInputChecked})}
                label={langPlace.couple}
                checked={(bCouple)? true: false}
                labelStyle={{color: '#ffffff', fontWeight: 500}}
                iconStyle={{fill: '#ffffff'}}
              />
            </div>*/}
            {(travel === 0)?
              <div className='col-md-12'>
                <Checkbox onCheck={(evt, isInputChecked) => updateValues({'bFamily': isInputChecked})}
                  label={langPlace.family}
                  checked={(bFamily)? true: false}
                  labelStyle={{color: '#ffffff', fontWeight: 500}}
                  iconStyle={{fill: '#ffffff'}}
                />
              </div>
            :''}
          </div>
        </div>

        <div className='footer row' {...footerProps}>
          <span {...nextProps}>{langPlace.confirm}<i className="fa fa-chevron-circle-right" aria-hidden="true"/></span>
        </div>

		  </div>
    )
  }
}

export default connect(
	(state) => ({settings: state.settings, values: state.data.values}),
  {updateSettings, updateValues, fetchAvailableDates}
)(formPassenger)



// WEBPACK FOOTER //
// ./src/shared/routes/components/fastbooking/panelPassenger.js